import { keyframes, styled } from 'styled-components';

const BUTTON_SIZE = 48;
const VISIBLE_OFFSET = 18;

const fadeIn = () => keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(${VISIBLE_OFFSET}px);
  }

  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
`;

const fadeOut = () => keyframes`
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }

  to {
    opacity: 0;
    transform: translateX(-50%) translateY(${VISIBLE_OFFSET}px);
  }
`;

export const ArrowButton = styled.button`
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  touch-action: manipulation;
  user-select: none;
  background: color-mix(in srgb, ${({ theme }) => theme.colors.black_1} 50%, transparent);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  transform: translateY(calc(${BUTTON_SIZE}px - ${VISIBLE_OFFSET}px));
  transition:
    transform 0.15s ease,
    padding-top 0.15s ease;
  &:hover,
  &:focus-within {
    transform: translateY(calc(${BUTTON_SIZE}px / 2));
    padding-top: 2px;
  }

  @media (hover: none) {
    &:active {
      transform: translateY(calc(${BUTTON_SIZE}px - ${VISIBLE_OFFSET}px));
    }
  }
`;

export const ArrowTrack = styled.div<{ $visible: boolean }>`
  position: fixed;
  left: 50%;
  bottom: env(safe-area-inset-bottom, 0);
  z-index: 99;
  transform: translateX(-50%);
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  animation: ${({ $visible }) => ($visible ? fadeIn : fadeOut)} 0.15s ease forwards;
`;
